import * as moment from 'moment'


export class SearchHelper {
    static MULTIPLE_FIELDS = [
        'anyname',
        'anyaddress',
    ]

    /**
     * Generate a search query from provided data
     * @param arrayAttribute The array of attributes to search
     * @param objectValue The object that has each attribute is a attribute to search and the value of each attribute is the value to search. The value should be either string, number, or array type
     * @param arrayConfig The array of config for each searching attribute. This array will be used if user perform searching for custom field.
     * @param isPresentationMode Presentation mode flag
     */
    static buildQuery(arrayAttribute: Array<string>, objectValue: { [key: string]: any }, arrayConfig: Array<filterStructureInformation>, isPresentationMode: boolean = false): string {
        if (arrayAttribute.length == 0 || arrayConfig.length == 0) {
            /**
             * Return empty query if searching attribute or searching configuration is empty
             */
            return isPresentationMode ? '{"presentationName":{"_$nin":[null,""]}}' : '{}'
        } else {
            const searchList = []
            if (isPresentationMode) {
                searchList.push('"presentationName":{"_$nin":[null,""]}')
            }
            arrayAttribute.forEach((searchAttribute, index) => {
                const searchValue = objectValue[searchAttribute]
                if (searchValue != null) {
                    let attribute = '"' + searchAttribute + '": '
                    switch (typeof searchValue) {
                        /**
                         * In case the search value is object type (array, pure object)
                         * The relationship between each value (item in array) is **AND** relationship
                         */
                        case 'object':
                            if (Array.isArray(searchValue)) {
                                if (searchValue.length != 0) {
                                    //$all items in array match
                                    attribute += '{"$all": ["' + searchValue.join('","') + '"]}'
                                } else {
                                    attribute += '{"_$exists": true, "_$ne": null, "_$ne": ""}'
                                }
                            } else {
                                attribute += JSON.stringify(searchValue)
                            }

                            break
                        case 'number':
                            /**
                             * In case the value is number type (date time)
                             * The value will be parsed by momentJS and append directly with attribute
                             */
                            const searchDate = moment(searchValue).utc().startOf('day').valueOf()
                            attribute += searchDate
                            break
                        default:
                            /**
                             * In case the value is other
                             */
                            if (!searchValue) {
                                /**
                                 * If the search attribute is anyname, the search value will be [null]
                                 * However, if the search attribute is different, it will search all the record that
                                 * exists the value of the attribute.
                                 */
                                if (this.MULTIPLE_FIELDS.indexOf(searchAttribute) >= 0) {
                                    attribute += '{"_$regex": "(?![ 　]).+"}'
                                } else {
                                    attribute += '{"_$exists": true, "_$ne": null, "_$ne": ""}'
                                }
                            } else {
                                /**
                                 * In case the search was just a string (from text input, etc)
                                 * The search text will be trimmed and use regex to search if it's text-input value, or directly search
                                 * equal if the search type is button.
                                 */
                                const tmpTrim = '"' + searchValue.trim() + '"'
                                const findItem = arrayConfig.find(item => {
                                    return item.propertyName == searchAttribute
                                })
                                if (findItem) {
                                    if (findItem['schema'] && findItem['schema']['uiType'] == 'button') {
                                        attribute += tmpTrim
                                    } else {
                                        attribute += '{"_$regex":' + tmpTrim + ', "_$options": "i"}'
                                    }
                                }
                            }
                            break
                    }
                    /**
                     * Append all existing search attribute to an array
                     */
                    searchList.push(attribute)
                }
            })

            /**
             * Join all the attribute in the search list and return as an object stringified
             */
            let searchQuery = searchList.join(',')
            searchQuery = '{' + searchQuery + '}'
            return searchQuery
        }
    }
}

/**
 * The general structure for custom search attribute configuration
 */
interface filterStructureInformation {
    propertyName: string,
    title: string,
    type: any,
    schema: {
        options?: Array<{
            _id: string|number,
            title?: string,
            firstName?: string,
            [key: string]: any
        }>,
        type: string,
        uiType?: string,
        uiConditionType?: string,
        uiOptions?: any|{
            behavior?: string,
            [key: string]: any
        }
    },
    isCondition?: boolean,
    isListField?: boolean,
    en?: string,

    [key: string]: any
}




// WEBPACK FOOTER //
// ./src/helper/search.helper.ts